import './scss/main.scss';
import { initSiteHeader } from './js/globals/site-header.js';
import './js/globals/price-modal.js';
import './js/globals/sticky-models-nav.js';
import { initFaq } from './js/modules/faq.js';
import { initModels } from './js/modules/models.js';
import { initReviews } from './js/modules/reviews.js';
import { initGallery } from './js/modules/gallery.js';

document.addEventListener('DOMContentLoaded', () => {
    initSiteHeader();
    initFaq();
    initModels();
    initReviews();
    initGallery();
});
